import { utxo } from '../utxo.js';
import { blockcypherMethods } from './methods.js';
export const blockcypher = (config) => utxo(config?.baseUrl || 'https://api.blockcypher.com/v1/btc/main', {
    name: 'Blockcypher API',
    key: 'blockcypher',
    methods: {
        include: Object.keys(blockcypherMethods),
    },
    ...config,
});
//# sourceMappingURL=blockcypher.js.map